import React from "react";
import ToDoARExperience from "../products/todoar/ToDoARExperience";

export default function GatewayDoARPage() {
  return <ToDoARExperience variant="standalone" />;
}

export { ACCEPTED_FILES, isSpatialClassification } from "../products/todoar/useToDoARSession";
